import React, { FC } from "react";
import SubscriptionCardButton from "./SubscriptionCardButton";

type PropsType = {
  currentPlan: any;
};

const BetaPlanBannerCard: FC<PropsType> = ({ currentPlan }) => {
  const productGuid =
    currentPlan?.subscriptionPricingPlan?.subscriptionPlanProduct?.productType
      ?.guid;

  return (
    <div className="ni-dash-cockpit ni-dash-cockpit--beta">
      <div className="ni-dash-beta-ribbon">BETA</div>

      <div className="ni-dash-beta-body">
        <div className="ni-dash-beta-content">
          <div className="ni-dash-beta-emblem" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l2.39 7.36H22l-6.19 4.5L18.2 21 12 16.5 5.8 21l2.39-7.14L2 9.36h7.61L12 2z" />
            </svg>
          </div>
          <div className="ni-dash-beta-message">
            You&rsquo;re part of our exclusive{" "}
            <strong>beta community</strong>.<br />
            Enjoy exploring <strong>all the features</strong>.
          </div>
        </div>

        <div className="ni-dash-cockpit-actions">
          <SubscriptionCardButton havePlan={true} productGuid={productGuid} />
        </div>
      </div>
    </div>
  );
};

export default BetaPlanBannerCard;
